var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "portal-file-input",
      class: { "is-dragging": _vm.isDragging },
      on: {
        dragenter: function($event) {
          $event.preventDefault()
          _vm.isDragging = true
        },
        dragover: function($event) {
          $event.preventDefault()
          _vm.isDragging = true
        },
        dragleave: function($event) {
          $event.preventDefault()
          _vm.isDragging = false
        },
        drop: function($event) {
          $event.preventDefault()
          return _vm.handleDrop.apply(null, arguments)
        }
      }
    },
    [
      _c(
        "label",
        { staticClass: "file-input-trigger" },
        [
          _c("portal-icon", { attrs: { name: "paperclip", size: 18 } }),
          _c("span", [
            _c("strong", [_vm._v(_vm._s(_vm.label))]),
            _c("small", [_vm._v(_vm._s(_vm.placeholder))])
          ]),
          _c("input", {
            attrs: {
              type: "file",
              multiple: _vm.multiple,
              "aria-label": _vm.label
            },
            on: { change: _vm.handleSelection }
          })
        ],
        1
      ),
      _vm.value.length
        ? _c(
            "div",
            { staticClass: "selected-files" },
            _vm._l(_vm.value, function(file, index) {
              return _c(
                "span",
                { key: _vm.fileKey(file, index), staticClass: "selected-file" },
                [
                  _c("span", [_vm._v(_vm._s(file.name))]),
                  _c(
                    "button",
                    {
                      attrs: {
                        type: "button",
                        "aria-label": _vm.removeLabel + ": " + file.name
                      },
                      on: {
                        click: function($event) {
                          return _vm.removeFile(index)
                        }
                      }
                    },
                    [_c("portal-icon", { attrs: { name: "x", size: 13 } })],
                    1
                  )
                ]
              )
            }),
            0
          )
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }